import React from 'react';
import { RMSvgIconNames } from 'components/customComponents/CommonComponents/RMSvgIcon';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';

interface Props {
  title: string;
  iconName: RMSvgIconNames;
}

export const UnifiedLargeTabSelector = ({ title, iconName }: Props) => (
  <RMCustomButton
    title={title}
    iconProps={{ name: iconName }}
    titleClass="header-button-title"
    contentContainerClass="tab-selectors-header-button-container"
    contentOrientation="Vertical"
  />
);
